import { render, staticRenderFns } from "./TypDogTeoExp.vue?vue&type=template&id=1a60b7a9&"
import script from "./TypDogTeoExp.vue?vue&type=script&lang=js&"
export * from "./TypDogTeoExp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports